import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { createWaitingArea, resetCreateWAForm } from '../../../../actions/waitingArea';
import { getUserBasicProfile } from '../../../../actions/user';
import { trimSlashAtTheEnd } from 'businessLogic/selfProvision.js';
import { forceValidation } from '../../../../businessLogic/validation.js';
import { hideGlobalMessage } from '../../../../actions/globalMessage';
import { updateShowCreateWaitingAreaModal, updateShowWelcomeWAMessage } from '../../../../actions/modal';
import { redirectToInternalLink } from 'businessLogic/redirector.js';
import Info from '../../info';
import { selectWaitingArea, getWaitingArea } from '../../../../actions/waitingArea';
export default function RightPanel(props) {
  const dispatch = useDispatch();
  const [createWAForm, setCreateWAForm] = useState(props.createWAForm);
  const [isCreateWASaving, setIsCreateWASaving] = useState(false);

  const updateCreateWA = (e) => {
    // Avoid multiple button clicks
    if (isCreateWASaving) {
      return;
    }

    let areThereErrors = forceValidation(undefined, undefined, 'createWAForm');
    if (!areThereErrors && !window.$(e.target).hasClass('disable') && props.createWAForm.networkTypeId > 0) {
      let cb = (result, response) => {
        if (result) {
          props.searchInEntityPageByName(wa.waitingAreaName, () => {
            resetForm();
            setIsCreateWASaving(false);
          });
        } else {
          //in case of any failure
          setIsCreateWASaving(false);
        }
      };

      setIsCreateWASaving(true);
      var wa = props.createWAForm;
      wa.organisationNetworkId = props.organisation.networkId;
      // remove the trailing slash before saving
      let waitingAreaUrl = wa.waitingAreaUrl;
      wa.waitingAreaUrl = trimSlashAtTheEnd(waitingAreaUrl);
      dispatch(createWaitingArea(wa, cb));
    }
  };

  const cancelWASelfProvision = () => {
    if (isCreateWASaving) {
      //when saving we dont want to cancel
      return;
    }
    if (window.$('.global-message.color-bad-things-bg:visible').length > 0) dispatch(hideGlobalMessage());
    resetForm();
  };

  const resetForm = () => {
    dispatch(updateShowCreateWaitingAreaModal(false));
    dispatch(resetCreateWAForm());
  };

  let saveClasses =
    'ui  labeled icon button icon left-text color-button color-button-hover color-white max-width  mrlnull mrbnull disable';
  let cancelClass =
    'ui  labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width mrtm mrlnull mrbnull';
  return (
    <div>
      <div className="ui actions mrbl max-width noTopMarginTablet">
        <button
          tabIndex="5"
          type="button"
          onClick={updateCreateWA}
          data-group="createWAForm"
          className={isCreateWASaving ? saveClasses + ' loading' : saveClasses}
        >
          {APP.LANGUAGE.Save}
          <i className="checkmark  icon" />
        </button>
        <button
          tabIndex="6"
          type="button"
          onClick={cancelWASelfProvision}
          className={isCreateWASaving ? cancelClass + ' disable' : cancelClass}
        >
          <i className="remove  icon" />
          {APP.LANGUAGE.Cancel}
        </button>
      </div>
      <div className="mrtl">
        <Info paragraphs={[APP.LANGUAGE.SelfProvisionCreateWA.DetailPart1]} />
      </div>
    </div>
  );
}
